export default __webpack_public_path__ + "static/media/featSport.35b1f62d.png";